import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const gapCursorPluginKey: PluginKey = new PluginKey('gapCursorPlugin');
